import axios from "axios";

import type { AxiosRequestConfig, AxiosRequestTransformer } from "axios";

export * from "@/api/marimo-api.generated";
export * from "@/api/marimo-api.generated.schemas";

export const getMarimoFilesBaseUrl = (sessionId: string) => `/marimo-api/files/${sessionId}/`;

export function getMarimoRequestConfig(token: string): AxiosRequestConfig {
  return {
    transformRequest: [
      (data, headers) => {
        headers.Authorization = `Bearer ${token}`;
        return data as unknown;
      },
      ...(axios.defaults.transformRequest as AxiosRequestTransformer[]),
    ],
  };
}
